"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A Button component. In addition to the props listed below, a Blueprint Button
 * inherits all the props from a
 * [react-bootstrap Button](https://react-bootstrap-v4.netlify.app/components/buttons/#button-props).
 *
 * # Variants
 *
 * ## Primary
 *
 * Primary button is the default variant for the Button component.
 *
 * #### Props
 *
 *  * `variant` (String): "primary"
 */
const Button = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    label,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, props, {
    ref: ref
  }), label, children);
});
Button.displayName = 'Button';
var _default = exports.default = Button;
Button.propTypes = {
  /**
   * The contents of the Button.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Set the The disabled state of both the label and input.
   */
  disabled: _propTypes.default.bool,
  /**
   * Providing a href will render an <a> element, styled as a button.
   */
  href: _propTypes.default.string,
  /**
   * Button contents
   */
  label: _propTypes.default.string,
  /**
   * The click event handler
   */
  onClick: _propTypes.default.func,
  /**
   * Adds the appropriate rel when 'target="_blank" is used.
   */
  rel: _propTypes.default.string,
  /**
   * Opens the link/target in one of the following
   */
  target: _propTypes.default.oneOf(['_self', '_blank', '_parent', '_top', null]),
  /**
   * Set the Button to an active state
   */
  type: _propTypes.default.oneOf(['button', 'submit', 'reset', null]),
  /**
   * What type of button is it?
   */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'link', 'inline'])
};
Button.defaultProps = {
  disabled: false,
  href: null,
  rel: null,
  target: null,
  type: 'button',
  variant: 'primary'
};